import { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { productService } from '../../services/productService';

/**
 * Più codici articolo, scelti cercando nel catalogo per codice o descrizione,
 * o scritti e confermati con Invio. Per l'Aggiornamento diretto di Articoli.
 */
export default function CodiciArticoloCombobox({ scelti, onChange }: {
  scelti: string[];
  onChange: (codici: string[]) => void;
}) {
  const [q, setQ] = useState('');
  const [aperta, setAperta] = useState(false);
  const [opzioni, setOpzioni] = useState<{ sku: string; title: string }[]>([]);

  useEffect(() => {
    const testo = q.trim();
    if (testo.length < 2) { setOpzioni([]); return; }
    let annullata = false;
    const t = setTimeout(() => {
      productService.list({ q: testo, limit: 8 })
        .then((r) => { if (!annullata) setOpzioni(r.items.map((p) => ({ sku: p.sku, title: p.title }))); })
        .catch(() => { if (!annullata) setOpzioni([]); });
    }, 250);
    return () => { annullata = true; clearTimeout(t); };
  }, [q]);

  const aggiungi = (codice: string) => {
    const c = codice.trim();
    if (c && !scelti.includes(c)) onChange([...scelti, c]);
    setQ('');
    setOpzioni([]);
  };
  const filtrate = opzioni.filter((o) => !scelti.includes(o.sku));

  return (
    <div className="relative">
      <div className="flex flex-wrap items-center gap-1 min-h-10 rounded-lg border bg-white px-3 py-1.5 focus-within:ring-2 focus-within:ring-[#2B5EA7]/30">
        {scelti.map((c) => (
          <span key={c} className="inline-flex items-center gap-1 rounded-full border bg-blue-50 border-blue-200 text-blue-800 px-2 py-0.5 text-[11px] font-mono">
            {c}
            <button type="button" aria-label={`Togli ${c}`} onClick={() => onChange(scelti.filter((x) => x !== c))}>
              <X className="h-3 w-3" />
            </button>
          </span>
        ))}
        <input
          id="diretto-codici-articolo"
          value={q}
          onChange={(e) => { setQ(e.target.value); setAperta(true); }}
          onFocus={() => setAperta(true)}
          onBlur={() => setTimeout(() => setAperta(false), 150)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && q.trim()) { e.preventDefault(); aggiungi(q); }
            if (e.key === 'Backspace' && !q && scelti.length) onChange(scelti.slice(0, -1));
          }}
          placeholder={scelti.length ? '' : 'Cerca per codice o descrizione'}
          className="flex-1 min-w-24 bg-transparent text-sm outline-none"
          data-testid="diretto-codici-articolo"
        />
      </div>
      {aperta && filtrate.length > 0 && (
        <ul className="absolute z-20 mt-1 w-full rounded-lg border bg-white shadow-md text-sm max-h-56 overflow-auto">
          {filtrate.map((o) => (
            <li key={o.sku}>
              <button type="button" onMouseDown={() => aggiungi(o.sku)} className="w-full text-left px-3 py-2 hover:bg-gray-50">
                <span className="font-mono">{o.sku}</span> <span className="text-muted-foreground">{o.title}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
